import(/* webpackMode: "eager" */ "/vercel/path0/src/app/connect/page.tsx");
